import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const PlatformContext = createContext(null);

export const PlatformProvider = ({ children }) => {
  const [platformConfig, setPlatformConfig] = useState({
    discord_url: "https://discord.gg/traktirkan",
    whatsapp_url: "",
    instagram_url: "https://instagram.com/traktirkan",
    facebook_url: "https://facebook.com/traktirkan",
    youtube_url: "https://youtube.com/@traktirkan",
  });
  const [loading, setLoading] = useState(true);

  const fetchConfig = async () => {
    try {
      const res = await api.get('/platform/config');
      if (res.data) {
        setPlatformConfig(res.data);
      }
    } catch (err) {
      console.error('Failed to load platform config', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <PlatformContext.Provider value={{ platformConfig, refreshPlatformConfig: fetchConfig, loading }}>
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatform = () => useContext(PlatformContext);
